export default "__VITE_ASSET__CyPCFHoD__"